import API from '../../services/aero-api';
import { API_NAMES } from '../../services/api-names';

export async function getNotes(patientId?: string) {
  if (!patientId) throw new Error('Missing patient Id');
  const notes = await API.get(API_NAMES.NOTES, `/v1/notes/patients/${patientId}`, {}) || [];
  return notes;
}
